/* eslint-disable no-shadow */
/* eslint-disable react/forbid-prop-types */
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import cx from 'classnames';
import partition from 'lodash/partition';
import isEqual from 'lodash/isEqual';
import {
  BadgeCollection,
  Button,
  containerQueryProps,
  DayButton,
  DayOfEventCard,
  DropdownGroup,
  GdaPromotional,
  GdaBanner,
  getTranslation,
  Icon,
  IconHeart,
  Loader,
  Link,
  PartnershipBranding,
  Rating,
  ResyCalendar,
  ShiftInventory,
  Tooltip,
  TranslationProvider,
  UpcomingEvents,
  utils,
  VenueImages,
  setMultiStepModalOpenState,
  setMultiStepModalVenueId,
  setMultiStepModalVenueContext,
  setMultiStepModalMode,
} from '@resy/ui-kitchen';

import ClampLines from '../../../../../ui-kitchen/src/components/ClampLines/ClampLines';
import Cookies from '../../../../../ui-kitchen/src/providers/Cookies';
import {
  STATE_AVAILABLE, NOT_AVAILABLE, CLOSED, SOLD_OUT,
} from '../../../../../ui-kitchen/src/utils/calendarStateDeterminer';
import Download from '../Download';
import BlogHero from '../BlogContent/BlogHero/BlogHero';
import MultiStepListModal from '../../../../../ui-kitchen/src/components/MultiStepListModal';
import { MODAL_MODES } from '../../../../../ui-kitchen/src/reducers/favoriteSlice';
import shareSVG from '../../../../../ui-kitchen/src/svg/icons/ic_share_20x20.svg';
import pinSVG from '../../../../../ui-kitchen/src/svg/icons/ic_location_20x20.svg';
import BlogContentShape from '../../../../../ui-kitchen/src/components/types/blogContent';
import VenueShape from '../../../../../ui-kitchen/src/components/types/venue';
import ReservationShape from '../../../../../ui-kitchen/src/components/types/reservations';
import NomaBanner, {
  NOMA_BANNER_TAGLINE, NOMA_CARD_OFFER, NOMA_BRAND_ICON, NOMA_LEARN_MORE_TEXT, NOMA_LEARN_MORE_LINK,
} from '../../../../../ui-kitchen/src/components/NomaBanner';
import USOpenBanner, {
  US_OPEN_BANNER_TAGLINE, US_OPEN_CARD_OFFER, US_OPEN_BRAND_ICON, US_OPEN_LEARN_MORE_TEXT, US_OPEN_LEARN_MORE_LINK,
} from '../../../../../ui-kitchen/src/components/USOpenBanner';
import GDABadge from '../../images/amexrga/gda-badge.svg';

import 'pure-react-carousel/dist/react-carousel.es.css';
import './VenuePage.scss';

import { ALL_DAY, ISO_DATE_FORMAT } from '../../../../../ui-kitchen/src/constants/resyCore';
import { DATE_TIME_FORMAT } from '../../../../../ui-kitchen/src/constants/dateFormats';
import { setSelectedCoreISODate } from '../../../../../ui-kitchen/src/reducers/resyCoreSlice';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import { selectIsCenturionEligible, selectIsPlatinumEligible } from '../../../../../ui-kitchen/src/reducers/userSlice';
import { setSearchParams } from '../../../../../ui-kitchen/src/utils/searchParamUtils';
import { setFunctionalCookie } from '../../../../../ui-kitchen/src/utils/resyUCMCookieUtils';
import { setReservation } from '../../../../../ui-kitchen/src/reducers';
import { usePrevious } from './usePrevious';
import { findSlotFromSlots } from '../../../../../ui-kitchen/src/utils/bookingHelpers';
import { isUSOpenVenueId } from '../../../../../ui-kitchen/src/utils/isUSOpenVenue';
import VenuePageSidebar from './VenuePageSidebar/VenuePageSidebar';
import getNomaVenueID from '../../../../../ui-kitchen/src/utils/getNomaVenueID';
import useExperiment from '../../../../../ui-kitchen/src/components/Experiments/useExperiment';
import { CONSUMER_RESY_CREDIT_DISCLAIMER_BANNER, RESY_CREDIT_TEMP_COPY } from '../../../../../ui-kitchen/src/constants/optimizelyExperiments';
import {
  US_OPEN_CENTURION_EXCLUSIVE_ID,
  US_OPEN_PLATINUM_EXCLUSIVE_ID,
} from '../../../../../ui-kitchen/src/constants/exclusiveIds';
import ResyCreditBanner from '../../../../../ui-kitchen/src/components/ResyCreditBanner';

const PLATINUM_EXCLUSIVE_ID = 5035;

const testId = 'venue-page';

const getUSOpenEligibilityByExclusiveId = ({
  exclusiveId,
  isCenturionEligible,
  isPlatinumEligible,
}) => {
  if (exclusiveId === US_OPEN_CENTURION_EXCLUSIVE_ID) {
    return !!isCenturionEligible;
  }
  if (exclusiveId === US_OPEN_PLATINUM_EXCLUSIVE_ID) {
    return !!isPlatinumEligible;
  }
  return undefined;
};

const { venueInventoryUtils, getLocationSlug } = utils;
let reserveWithGoogleTimer = null;
let loginThroughGatedSlotClickTimer = null;

const VenuePage = ({
  $rootScope, $routeParams, aboutVenue, activeNotifications, affiliatedRestaurants, Analytics, $translate, blogContent,
  clearTimeFilter, containerQuery, filterQuery, ImageServiceConfig, isAuthenticated, isFavorite, isMobile, isCenturionEligible, isPlatinumEligible, isVenueClosed, largePartyMessage,
  loadingReservations, maxQuantity, minQuantity, multiStepListModalName, multiStepListModalSlug, needToKnow, nextAvailableDate,
  nextAvailableDateFormatted, notifyData, onTimeChange, openModal, partnershipBranding, platinumNight, priceRange, recommendedVenues,
  reservations, searchSessionId, selectedDate, selectedDateFormatted, selectedQuantity, selectResy, selectedTime, setSelectedCoreISODate, showAuthModal,
  upcomingEvents, userIsGda, userIsPlatinumNight, venue, venueInventory, venueInventoryCache, whyWeLikeIt, setReservation, setMultiStepModalVenueContext,
  setMultiStepModalVenueId, setMultiStepModalMode, setMultiStepModalOpenState,
}) => {
  const [isResyCreditBannerEnabled] = useExperiment(CONSUMER_RESY_CREDIT_DISCLAIMER_BANNER);
  const [isResyCreditTempCopyEnabled] = useExperiment(RESY_CREDIT_TEMP_COPY);
  const [copyLinkActive, setCopyLinkActive] = React.useState(false);
  const [calendarOpen, setCalendarOpen] = React.useState(false);
  const [visible, setVisible] = React.useState(undefined);
  const prevVenue = usePrevious(venue);
  const isPageViewEventFired = useRef(false);
  const isUSOpenVenue = isUSOpenVenueId(venue?.id);

  const checkReserveWithGoogleReservation = (urlParams) => {
    const startSec = urlParams.get('start_sec');
    const rwgToken = urlParams.get('rwg_token');
    const roomId = urlParams.get('room_id');
    const availabilityTag = urlParams.get('availability_tag');

    const isUpdatedFeed = availabilityTag && availabilityTag.includes('rgs://resy/');

    // this is relevant to resy incident #106
    // availability_tag is the new url param
    // room_id is checked here in order for the feeds to be backwards compatibile
    const rwgConfig = isUpdatedFeed ? availabilityTag : roomId;

    // extracting needed data from the config token
    // rgs://resy/<venueId>/<template>/<serviceId>/<serviceDate>/<actualDate>/<time>/<partySize>/<tableType>
    const rwgConfigArray = rwgConfig.replaceAll('rgs://resy/', '').split('/');
    const [venueId, , , , date, time, partySize, tableType] = rwgConfigArray;

    // extracting table type from room id
    // room_id=<venueId>~<tableType>
    const table = isUpdatedFeed ? roomId.split('~')[1] : tableType;

    if (venueId && date && time && tableType) {
      const reservation = {
        seats: partySize || 2,
        startSec,
        availabilityTag, // data comes from urlParam 'availability_tag'
        roomId, // for backwards compatibility and table type, we check room_id
        rwgToken, // 'reserve with Google' token
        featureRecaptcha: venue.featureRecaptcha,
        venueName: venue.name,
        venueId,
        time: `${date} ${time}`,
        type: table,
      };

      const config = {
        seats: partySize || 2,
        date,
      };

      reserveWithGoogleTimer = setTimeout(() => {
        selectResy(config, reservation);
        setSearchParams('room_id', null);
        setSearchParams('start_sec', null);
        setSearchParams('rwg_token', null);
        setSearchParams('availability_tag', null);
      }, 1000);
    }
  };

  const handleReservationSelect = (reservation, stId, notifyService, targetEl) => {
    const notifyServiceType = notifyService || stId;
    const buttonFocusElement = targetEl?.nodeName === 'BUTTON' ? targetEl : targetEl?.parentNode;

    const config = {
      date: moment(selectedDate).format(ISO_DATE_FORMAT),
      seats: selectedQuantity,
    };

    const { pathname, search } = window.location;
    const destination = reservation?.tockBookingUrl ? 'tock' : 'resy';
    const analyticsPayload = {
      venue: venue.name,
      city: venue.location.city,
      context: utils.getPageContext(pathname, search),
      destination,
      'is event': !!(reservation?.event),
      event: reservation?.event?.title,
      'party size': selectedQuantity,
      ...(reservation?.time && { time: moment(reservation.time).format(DATE_TIME_FORMAT) }),
      'lead time': moment(reservation?.time).diff(moment().startOf('day'), 'days'),
      searchSessionId,
      details: {
        city: venue?.location?.city,
        currency: venue?.locale?.currency,
        serviceType: reservation?.serviceTypeName,
        venueId: venue?.id,
      },
    };

    Analytics.event('click booking slot', analyticsPayload);

    if (platinumNight && reservation?.exclusiveId === PLATINUM_EXCLUSIVE_ID) {
      reservation.module = 'platinum night';
    }

    if (reservation) {
      config.tableConfigId = reservation.token;
      const usOpenEligibility = isUSOpenVenue
        ? getUSOpenEligibilityByExclusiveId({
          exclusiveId: reservation?.exclusiveId,
          isCenturionEligible,
          isPlatinumEligible,
        })
        : undefined;
      const reservationIsEligible = usOpenEligibility ?? reservation.isEligible;

      if (!reservationIsEligible) {
        if (isAuthenticated) {
          setReservation({ ...reservation, venueName: venue.name });
          $rootScope.$broadcast('MODAL', 'gating-error');
        } else {
          setSearchParams('token', reservation.token);
          setSearchParams('exclusiveId', reservation.exclusiveId);
          setSearchParams('scrollY', window.scrollY);
          showAuthModal();
        }
      } else {
        selectResy(config, reservation, buttonFocusElement);
      }
    }

    if (notifyServiceType) {
      config.notifyService = notifyServiceType;
      selectResy(config, reservation, buttonFocusElement);
    }
  };

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const roomId = urlParams.get('room_id');
    const token = urlParams.get('token');
    const exclusiveId = urlParams.get('exclusiveId');
    const scrollY = urlParams.get('scrollY');

    const clearTokenAndExclusiveId = () => {
      setSearchParams('token', null);
      setSearchParams('exclusiveId', null);
      setSearchParams('scrollY', null);
    };

    const loginThroughGatedSlotClick = (reservations, token, exclusiveId) => {
      const slotFound = findSlotFromSlots(reservations, token, Number(exclusiveId));
      if (slotFound) {
        loginThroughGatedSlotClickTimer = setTimeout(() => {
          window.scrollTo(0, scrollY);
          handleReservationSelect(slotFound, null, null, null);
          clearTokenAndExclusiveId();
        }, 1000);
      } else {
        loginThroughGatedSlotClickTimer = setTimeout(() => {
          clearTokenAndExclusiveId();
        }, 1000);
      }
    };

    if (roomId && prevVenue && Object.keys(prevVenue).length === 0
      && Object.keys(venue).length > 0) {
      checkReserveWithGoogleReservation(urlParams);
    }

    // If user is on the US Open venue page, default selected date to today.
    if (prevVenue && !isEqual(prevVenue, venue) && isUSOpenVenue) {
      const selectedISODate = moment().format(ISO_DATE_FORMAT);
      setSelectedCoreISODate(selectedISODate);
    }

    if (reservations && venue?.id && token) {
      loginThroughGatedSlotClick(reservations, token, exclusiveId);
    }

    if (venue?.name) {
      Analytics?.setVenueName?.(venue.name);
    }

    if (venue?.id) {
      Analytics?.setVenueId?.(venue.id);
    }

    if (venue?.id && !isPageViewEventFired.current) {
      isPageViewEventFired.current = true;
      if (venue.isGda) {
        Analytics.event('view gda page', {
          context: 'venue page',
        });
      }
    }
  }, [venue, reservations]);

  const hasLoggedVenueInventory = React.useRef(false);

  React.useEffect(() => {
    if (!venue?.id || loadingReservations) {
      return;
    }
    const slotCount = venueInventoryUtils.getVisibleSlotCount(reservations);
    Analytics?.setVenueInventory?.({
      'availability slot count': slotCount,
      'availability source': hasLoggedVenueInventory.current ? 'filter update' : 'initial load',
    });
    hasLoggedVenueInventory.current = true;
  }, [reservations, loadingReservations, venue?.id]);

  React.useEffect(() => () => {
    clearTimeout(reserveWithGoogleTimer);
    clearTimeout(loginThroughGatedSlotClickTimer);
    Analytics?.setVenueName?.(null);
    Analytics?.setVenueInventory?.(null);
    Analytics?.setVenueId?.(null);
    if (!Cookies.get('gda-tooltip-visited')) {
      const GDAVisitedCookieCleanup = setFunctionalCookie('gda-tooltip-visited', true);
      GDAVisitedCookieCleanup();
    }
  }, []);

  const renderResyRating = (venue) => {
    if (!venue.rater || venue.rater?.length === 0 || venue.rater[0].name !== 'Resy') {
      return null;
    }

    const rating = venue.rater[0];

    return (
      <div className="VenuePage__rating__container" key={`${rating.name}_${rating.score}`}>
        <Rating
          score={rating.score}
          totalRatings={rating.total}
        />
        <div className="separator" />
      </div>
    );
  };

  const renderThirdPartyRating = (venue) => {
    if (!venue.rater || venue.rater?.length < 2) {
      return null;
    }

    const rating = venue.rater[1];

    return (
      <Rating
        key={`${rating.name}_${rating.score}`}
        attribution={rating.name}
        scale={rating.scale}
        score={rating.score}
        thirdParty
        totalRatings={rating.total}
      />
    );
  };

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      Analytics.event('share venue', {
        venue: venue?.name,
        venue_id: venue?.id,
        city: venue?.location?.city,
        share_method: 'copy_link',
      });
      setCopyLinkActive(true);
      setTimeout(() => {
        setCopyLinkActive(false);
      }, 2000);
    });
  };

  const handleHeartIconClick = () => {
    const showMultiListModal = () => {
      setMultiStepModalVenueContext({ name: venue?.name, city: venue?.location?.city });
      setMultiStepModalVenueId(venue.id);
      setMultiStepModalMode(MODAL_MODES.ADD_TO_LIST);
      setMultiStepModalOpenState(true);
    };

    if (isAuthenticated) {
      showMultiListModal();
    } else {
      showAuthModal(showMultiListModal);
    }
  };

  const renderSaveButton = (isFavorite) => (
    <Button
      variant="black-small"
      onClick={handleHeartIconClick}
      data-test-id={`${testId}-save`}
    >
      <IconHeart height={16} on={isFavorite} width={16} />
      {isFavorite ? (
        <TranslationProvider translationKey="saved">
          Saved
        </TranslationProvider>
      ) : (
        <TranslationProvider translationKey="save">Save</TranslationProvider>
      )}
    </Button>
  );

  const renderShareButton = () => {
    if (copyLinkActive) {
      return (
        <Button
          variant="black-small"
          onClick={copyLink}
          data-test-id={`${testId}-copy-link-active`}
          aria-checked={false}
        >
          <Icon component={shareSVG} height={16} name="upload" width={16} />
          <TranslationProvider translationKey="button_copied_bang">
            Copied!
          </TranslationProvider>
        </Button>
      );
    }

    return (
      <Button
        variant="black-small"
        onClick={copyLink}
        data-test-id={`${testId}-copy-link`}
        aria-checked
        aria-live="polite"
      >
        <Icon component={shareSVG} height={16} name="upload" width={16} />
        <TranslationProvider translationKey="share">
          Share
        </TranslationProvider>
      </Button>
    );
  };

  const getSelectedTimeValue = () => {
    if (selectedTime === ALL_DAY || !selectedTime) {
      return undefined;
    }
    return moment(selectedTime, 'HHmm').format('LT');
  };

  const renderInventory = (inventoryByDay) => {
    const canSeeMessage = !venue.isGdaOnly || userIsGda;

    if (!loadingReservations && inventoryByDay && !inventoryByDay[$routeParams.date] && canSeeMessage) {
      return (
        <TranslationProvider translationKey="no_availability_message" translationValues={{ selectedDate: selectedDateFormatted }}>
          <div className="VenuePage__context-text">
            At the moment, there&apos;s no online availability for
            {selectedDateFormatted}
            .
          </div>
        </TranslationProvider>
      );
    }

    let isClosedOnSelectedDate = false;
    let eventsExistOnDay = false;

    if (inventoryByDay && inventoryByDay[$routeParams.date]) {
      const availabilityValues = new Set(Object.values(inventoryByDay[$routeParams.date]));
      isClosedOnSelectedDate = availabilityValues.size === 1 && availabilityValues.has(CLOSED);

      const eventValue = inventoryByDay[$routeParams.date].event;
      eventsExistOnDay = eventValue === STATE_AVAILABLE || eventValue === SOLD_OUT;
    }

    return (
      <ShiftInventory
        activeNotifications={activeNotifications}
        Analytics={Analytics}
        clearTimeFilter={clearTimeFilter}
        eventsExistOnDay={eventsExistOnDay}
        filterQuery={filterQuery}
        isClosedOnSelectedDate={isClosedOnSelectedDate}
        isGdaUser={userIsGda}
        isInventoryAvailableForDate={inventoryByDay?.[$routeParams.date]?.reservation === STATE_AVAILABLE}
        isVenueClosed={isVenueClosed}
        largePartyMessage={largePartyMessage}
        loadingReservations={loadingReservations}
        maxQuantity={maxQuantity}
        nextAvailableDate={nextAvailableDate}
        nextAvailableDateFormatted={nextAvailableDateFormatted}
        notifyData={notifyData}
        onDateSelect={setSelectedCoreISODate}
        onReservationSelect={handleReservationSelect}
        platinumNight={platinumNight}
        recommendedVenues={recommendedVenues}
        reservations={reservations}
        selectedQuantity={selectedQuantity}
        selectedDateFormatted={selectedDateFormatted}
        selectedTimeFormatted={getSelectedTimeValue()}
        venue={venue}
        shopSmallValue={$routeParams?.shopsmall}
      />
    );
  };

  const renderGdaPromotionalConcierge = () => {
    if (venue.isGda && venue.gdaConciergeBooking) {
      return (
        <GdaPromotional
          variant="concierge"
          login={showAuthModal}
          venue={venue.name}
          city={venue.location.city}
        />
      );
    }
    return null;
  };

  const renderGdaBanner = () => {
    const bannerText = 'Unlock Global Dining Access with an eligible American Express®️ Card';
    if (venue.isGda && !userIsGda) {
      return (
        <GdaBanner bannerText={bannerText} translationKey="gda_banner_text" icon={GDABadge} />
      );
    }

    return null;
  };

  const renderGdaExclusive = () => {
    if (venue.isGdaOnly && venue.isGda && !userIsGda) {
      return (
        <>
          <TranslationProvider translationKey="gda_only_venue">
            <p className="VenuePage__gda-only">This restaurant reserves tables exclusively for Global Dining Access members only.</p>
          </TranslationProvider>
          <GdaPromotional
            Analytics={Analytics}
            variant="venue"
            login={showAuthModal}
            venue={venue.name}
            city={venue.location.city}
          />
          {!needToKnow && <hr aria-hidden="true" />}
        </>
      );
    }

    return null;
  };

  const getUSOpenGatingErrors = () => ({
    message_1: US_OPEN_BANNER_TAGLINE,
    message_2: US_OPEN_CARD_OFFER,
    brand_icon: US_OPEN_BRAND_ICON,
    learn_more_text: US_OPEN_LEARN_MORE_TEXT,
    learn_more_link: US_OPEN_LEARN_MORE_LINK,
  });

  const getNomaGatingErrors = () => ({
    message_1: getTranslation({ fallback: NOMA_BANNER_TAGLINE, translationKey: 'noma_banner_tagline' }),
    message_2: getTranslation({ fallback: NOMA_CARD_OFFER, translationKey: 'noma_banner_add_eligible_card' }),
    brand_icon: NOMA_BRAND_ICON,
    add_card_text: getTranslation({ fallback: NOMA_CARD_OFFER, translationKey: 'noma_banner_add_eligible_card' }),
    learn_more_text: getTranslation({ fallback: NOMA_LEARN_MORE_TEXT, translationKey: 'noma_learn_more_text' }),
    learn_more_link: NOMA_LEARN_MORE_LINK,
  });

  const showGatingModal = () => {
    // Custom logic to show the gating / channeling modal to add eligible card https://resy.atlassian.net/browse/CON-13136
    // Isn't great cause the modal hooks into the reservation store data, so must set these values to display the modal copy.
    // Think about refactoring the gating modal to be a more flexible / generic
    const isUSOpenVenue = isUSOpenVenueId(venue?.id);
    const isNomaVenue = venue?.id === getNomaVenueID();

    const gatingErrors = () => {
      if (isUSOpenVenue) {
        return getUSOpenGatingErrors();
      } if (isNomaVenue) {
        return getNomaGatingErrors();
      }
      return {};
    };

    setReservation({
      exclusiveId: 0,
      gatingErrors: {
        0: gatingErrors(),
      },
    });

    $rootScope.$broadcast('MODAL', 'gating-error');
  };

  const renderUSOpenBanner = () => {
    const isNomaVenue = venue?.id === getNomaVenueID();
    const isUSOpenEligible = isAuthenticated
      && (getUSOpenEligibilityByExclusiveId({
        exclusiveId: US_OPEN_CENTURION_EXCLUSIVE_ID,
        isCenturionEligible,
        isPlatinumEligible,
      })
      || getUSOpenEligibilityByExclusiveId({
        exclusiveId: US_OPEN_PLATINUM_EXCLUSIVE_ID,
        isCenturionEligible,
        isPlatinumEligible,
      }));
    const isPlatinumNightEligible = isAuthenticated && userIsPlatinumNight;

    // Custom banner for us open users that are not logged in or not eligible https://resy.atlassian.net/browse/CON-13135
    if (isUSOpenVenue && !isUSOpenEligible) {
      return (
        <USOpenBanner
          isUserLoggedIn={isAuthenticated}
          onLogin={showAuthModal}
          onAddCard={showGatingModal}
        />
      );
    }

    if (isNomaVenue && !isPlatinumNightEligible) {
      return (
        <NomaBanner
          isUserLoggedIn={isAuthenticated}
          onLogin={showAuthModal}
          onAddCard={showGatingModal}
        />
      );
    }

    return null;
  };

  const handleBookEvent = (event) => {
    const {
      date,
      maxPartySize,
      price,
      url_slug: urlSlug,
      venue,
    } = event;
    const locationSlug = getLocationSlug(venue.location);
    const reservationConfig = {
      venueId: venue.id,
      date,
      widgetPath: `cities/${locationSlug}/venues/${venue.url_slug}/events/${urlSlug}`,
      maxPartySize,
      price,
    };

    openModal(reservationConfig);
  };

  const getTodayEventLink = (event) => {
    const locationSlug = getLocationSlug(venue.location);
    return `cities/${locationSlug}/venues/${venue.urlSlug}/events/${event.url_slug}`;
  };

  const getBlogPostProps = (blogPost) => {
    const image = blogPost.image?.sizes['resy-md']?.url || '';
    const name = blogPost.kicker_title;
    const tagUrl = blogPost.kicker_url;
    return {
      ...blogPost,
      key: blogPost.url,
      containerQuery,
      image,
      name,
      tagUrl,
    };
  };

  const formatOriginalImages = (imageObj) => {
    if (!imageObj) return [];
    const imgKeys = Object.keys(imageObj);
    return imgKeys.map((key) => ({
      id: key,
      url: `${imageObj[key]?.url}/1600x1600`,
    }));
  };

  const renderVenueImages = () => {
    const galleryThumbnailPhotos = utils.getBestVenueImages(venue?.responsiveImages?.urls_by_resolution, true);
    const originalPhotoArray = formatOriginalImages(venue?.responsiveImages?.originals);

    return (
      <VenueImages
        images={venue.images}
        galleryImages={originalPhotoArray}
        galleryThumbnails={galleryThumbnailPhotos}
        venueId={venue.id}
        isMobile={isMobile}
        ImageServiceConfig={ImageServiceConfig}
      />
    );
  };

  const toggleCalendar = async () => {
    setCalendarOpen(!calendarOpen);
  };

  const handleDateSelect = (date) => {
    const selectedISODate = moment(date).format(ISO_DATE_FORMAT);
    setSelectedCoreISODate(selectedISODate);
    toggleCalendar();
  };

  const closeCalendar = () => {
    setCalendarOpen(false);
  };

  const reduceInventory = (venueInventory) => venueInventory.scheduled.reduce((map, item) => {
    // eslint-disable-next-line no-param-reassign
    map[item.date] = item.inventory;
    return map;
  }, {});

  const isDateOutsideCalendarRange = (date, limit) => {
    if (!date) {
      return false;
    }

    const today = new Date(moment().format(ISO_DATE_FORMAT));
    const timeDifference = date.getTime() - today.getTime();
    const daysDifference = timeDifference / (1000 * 3600 * 24);

    return daysDifference > limit;
  };

  const handleQuickCalendarClick = (date) => {
    const selectedISODate = moment(date).format(ISO_DATE_FORMAT);

    setSelectedCoreISODate(selectedISODate);
  };

  const renderQuickCalendar = () => {
    if (!venueInventory.scheduled || !$rootScope.matchMedia?.md || loadingReservations) {
      return null;
    }

    let limit = 7;
    if ($rootScope.matchMedia.lg) {
      limit = 9;
    }
    if ($rootScope.matchMedia.xl) {
      limit = 11;
    }

    if (isDateOutsideCalendarRange(selectedDate, limit)) {
      return null;
    }
    const doesAvailabilityExist = venueInventory?.scheduled && venueInventory?.scheduled.some((schedule) => schedule?.state?.state === STATE_AVAILABLE);
    const quickPickerEllipsisClass = cx(
      'VenuePage__calendar__quick-picker__ellipsis',
      {
        'no-availability': !doesAvailabilityExist,
      }
    );

    return (
      <div className="VenuePage__calendar__quick-picker__container">
        {venueInventory.scheduled?.slice(0, limit).map((item) => (
          <div key={item.date} className="VenuePage__calendar__quick-picker__date">
            <div className="VenuePage__calendar__quick-picker__day">
              {moment(item.date).format('dd')}
            </div>
            <DayButton
              date={moment(item.date)}
              onClick={/* istanbul ignore next */ () => handleQuickCalendarClick(item.date, item.inventory)}
              selected={item.date === $routeParams.date}
              status={item.inventory}
            />
          </div>
        ))}
        <Button
          circle
          className={quickPickerEllipsisClass}
          aria-label={getTranslation({
            translationKey: 'date_picker',
            fallback: 'Date Picker',
          })}
          id="VenuePage__calendar__quick-picker__ellipsis"
          onClick={toggleCalendar}
          variant="secondary"
          data-test-id="venue-page-quick-calender"
        >
          &hellip;
        </Button>
      </div>
    );
  };

  const renderBlogContent = () => {
    if (!blogContent || blogContent?.length === 0) {
      return null;
    }

    const blogPostCount = blogContent?.length;
    let postsToRender;
    let herosToRender;

    if (blogPostCount >= 3) {
      // 1 hero, 3 posts
      postsToRender = blogContent.slice(1, 4);
      herosToRender = blogContent.slice(0, 1);
    } else if (containerQuery.lg) {
      // 0 heros, 2 posts for lg and above
      postsToRender = blogContent;
      herosToRender = [];
    } else {
      // 2 heros, 0 posts for smaller than lg
      postsToRender = [];
      herosToRender = blogContent;
    }

    return (
      <div className="VenuePage__blog-content container">
        <div className="row no-gutters">
          <div className="col-12">
            <hr />
          </div>
        </div>
        <div className="row no-gutters">
          <div className="VenuePage__blog-content__title col-12">
            <TranslationProvider translationKey="discover_venue" translationValues={{ venueName: venue.name }}>
              <h2 className="VenuePage__blog-content__discover-title" data-test-id={`${testId}-discover-venue__title`}>
                Discover
                {venue.name}
                {' '}
                &amp; More
              </h2>
            </TranslationProvider>
            {blogPostCount > 4 && containerQuery.lg
              && (
                <TranslationProvider translationKey="see_more">
                  <Link href={`https://blog.resy.com/venue/${venue.urlSlug}-${venue.id}`} data-test-id={`${testId}-see-more-blogs`}>
                    See More &rsaquo;
                  </Link>
                </TranslationProvider>
              )}
          </div>
        </div>

        <div className="row no-gutters">
          <div className={cx({
            'col-12 col-lg-6': herosToRender.length > 0,
          })}
          >
            {herosToRender.map((hero) => (
              <BlogHero
                {...getBlogPostProps(hero)}
                subtitle={hero.short_description}
                className="BlogHero--venue-page"
              />
            ))}
          </div>
          <div className={cx({
            'col-12 col-lg-6': postsToRender.length > 0 && herosToRender.length > 0,
            'col-12': postsToRender.length > 0 && herosToRender.length === 0,
          })}
          >
            <div className="VenuePage__blog-posts-scrollable row no-gutters">
              {postsToRender.map((blogPost, index) => (
                <div
                  className={cx('col-md-4', {
                    'col-7 col-lg-11 offset-lg-1': herosToRender.length > 0,
                    'offset-1': index !== 0 && !containerQuery.md,
                    'col-6': herosToRender.length === 0,
                    'VenuePage__blog-posts__md-offset': containerQuery.md && !containerQuery.lg,
                  })}
                  key={blogPost.url}
                >
                  <BlogHero
                    {...getBlogPostProps(blogPost)}
                    clampTitle
                    className="BlogHero--venue-page BlogHero--venue-page--small row no-gutters"
                    noSubtitle
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getVenueCollections = () => {
    if (!venue.isGda) {
      return venue.collections;
    }

    // if venue is GDA, don't include the GDA badge since the GDA banner also renders
    return venue.collections.filter((collection) => collection.type_id !== 10);
  };

  const toggleGdaOnboardingModal = () => {
    if (isMobile) setVisible(false);
    if (!userIsGda) {
      const { pathname } = window.location;
      Analytics?.event('view gda module', {
        context: utils.getPageContext(pathname),
        type: 'non GDA',
        value: 'venue badge',
      });
    }
    $rootScope.$broadcast('MODAL', 'onboarding-lite');
  };

  const renderTooltip = () => {
    const content = (
      <div className="VenuePage__tooltip">
        {userIsGda ? (
          <TranslationProvider translationKey="venue_page_gda_tooltip_member">
            As a Global Dining Access member, you get exclusive access to tables at this venue.
          </TranslationProvider>
        ) : (
          <TranslationProvider translationKey="venue_page_gda_tooltip">
            This venue sets aside tables for Global Dining Access members. Click to learn more.
          </TranslationProvider>
        )}
      </div>
    );

    return (
      <Tooltip
        theme="dark"
        content={content}
        offset={[0, 10]}
        trigger="mouseenter focus"
        hideOnClick
        arrow="round"
        showOnCreate={!Cookies.get('gda-tooltip-visited')}
        visible={visible}
        zIndex={1}
      >
        <Button
          aria-label={getTranslation({
            translationKey: 'rga',
            fallback: 'Global Dining Access',
          })}
          className="VenuePage__gda-badge-button"
          onClick={toggleGdaOnboardingModal}
          variant="no-style"
          data-test-id={`${testId}-gda-tooltip`}
        >
          <Icon
            className={cx('VenuePage__GDA-Badge', { 'VenuePage__GDA-Badge--mobile': isMobile })}
            component={GDABadge}
            name="GDA-badge"
            height="45px"
            width="45px"
          />
        </Button>
      </Tooltip>
    );
  };

  const renderHeader = (events) => {
    if (events[0].date) {
      const today = moment().format(ISO_DATE_FORMAT);
      const isToday = moment(events[0].date, ISO_DATE_FORMAT).isSame(today);

      const todayEventsHeader = events.length > 1 ? { key: 'venue_page_events_today_header', fallback: 'Today’s Events' } : { key: 'venue_page_event_today_header', fallback: 'Today’s Event' };
      const futureEventsHeader = events.length > 1 ? { key: 'venue_page_events_future_header', fallback: 'Featured Events' } : { key: 'venue_page_event_future_header', fallback: 'Featured Event' };
      const headerDesc = isToday ? todayEventsHeader : futureEventsHeader;

      return (
        <div className="DayOfEventCard--header">
          <div className="DayOfEventCard--header--event" />

          <TranslationProvider translationKey={headerDesc.key}>
            <div className="DayOfEventCard--header--name">{headerDesc.fallback}</div>
          </TranslationProvider>
        </div>
      );
    }

    return null;
  };

  const renderTodayEvents = (events = [], shouldNotRenderEvents = true) => {
    if (!events.length || shouldNotRenderEvents) {
      return null;
    }

    const isUSOpenVenue = isUSOpenVenueId(venue?.id);
    if (isUSOpenVenue) {
      return null;
    }

    return (
      <>
        { renderHeader(events) }

        {
        events.map((event, index) => (
          <DayOfEventCard
            event={event}
            index={index}
            key={event.url_slug}
            lastOfType={index === events.length - 1}
            matchMedia={$rootScope.matchMedia}
            onBookEvent={handleBookEvent}
            getTodayEventLink={getTodayEventLink}
          />
        ))
      }
      </>
    );
  };

  const dateLabel = $rootScope?.searchProps?.searchFields?.datepicker?.config?.label;
  const inventoryByDay = venueInventory && venueInventory.scheduled ? reduceInventory(venueInventory) : null;
  const month = inventoryByDay ? moment($rootScope?.searchProps?.searchFields?.datepicker?.model) : moment();
  const [todayEvents, futureEvents] = partition(upcomingEvents, (event) => event?.date === $routeParams.date);

  const isNomaVenue = venue?.id === getNomaVenueID();
  const isUSOpenEligible = isAuthenticated && (isCenturionEligible || isPlatinumEligible);
  const isPlatinumNightEligible = isAuthenticated && userIsPlatinumNight;
  const canRenderInventory = !isNomaVenue || isPlatinumNightEligible;
  const canRenderBookingExperience = canRenderInventory && (!isUSOpenVenue || isUSOpenEligible);

  if (!venue || Object.keys(venue).length === 0) {
    if (loadingReservations) return <Loader containerHeight="500px" className={`${testId}-loading-reservation`} />;
    return null;
  }

  return (
    <>
      <div className="VenuePage container">
        {isMobile && renderVenueImages()}
        <MultiStepListModal
          Analytics={Analytics}
          name={multiStepListModalName}
          urlSlug={multiStepListModalSlug}
        />

        <div className="row no-gutters">
          <div className="col-12 col-md-7">
            <div className="VenuePage__lockup-wrapper">
              <div className="VenuePage__lockup">
                <h1 className="VenuePage__venue-title">{venue.name}</h1>
                <div className="VenuePage__lockup-meta-share-save">
                  <div className="VenuePage__meta-container">
                    <div className="VenuePage__meta-container__cuisine-price">
                      {renderResyRating(venue)}
                      {venue.cuisine
                      && (
                        <>
                          <span className="cuisine">{venue.cuisine}</span>
                          <div className="separator" />
                        </>
                      )}
                      <span className="price-range">{priceRange}</span>
                    </div>

                    <div className="neighborhood">
                      <Icon component={pinSVG} iconClass="pin" role="img" ariaLabel="location" tabIndex="0" />
                      {venue.location.neighborhood}
                    </div>

                    <div className="VenuePage__badges-rating">
                      <BadgeCollection
                        badges={getVenueCollections()}
                        showLabels={false}
                      />
                      {renderThirdPartyRating(venue)}
                    </div>
                  </div>
                  { isMobile
                  && (
                  <div className="VenuePage__share-save">
                    <div className="VenuePage__share-save--inner-container">
                      {renderShareButton()}
                      {renderSaveButton(isFavorite)}
                    </div>
                  </div>
                  )}
                </div>
              </div>
              <div className={cx('VenuePage__share-save-gda-badge', { 'VenuePage__share-save-gda-badge__GDA-venue': venue.isGda })}>
                {venue.isGda && (
                <div data-test-id={`${testId}-gda-badge`}>
                  {renderTooltip()}
                </div>
                )}
                {!isMobile
                  && (
                  <div className="VenuePage__share-save">
                    <div className="VenuePage__share-save--inner-container">
                      {renderShareButton()}
                      {renderSaveButton(isFavorite)}
                    </div>
                  </div>
                  )}
              </div>
            </div>

            {whyWeLikeIt?.body
              && (
                <div className="VenuePage__why-we-like-it">
                  <hr />
                  <TranslationProvider translationKey="venue_why_we_like_it_header">
                    <div className="VenuePage__why-we-like-it__title" data-test-id={`${testId}-why-we-like-it__title`}>Why We Like It</div>
                  </TranslationProvider>
                  <div className="VenuePage__why-we-like-it__body" data-test-id={`${testId}-why-we-like-it__body`}>
                    {whyWeLikeIt.body}
                  </div>
                </div>
              )}

            {renderGdaPromotionalConcierge()}

            <div className="VenuePage__Selector-Wrapper">
              {canRenderBookingExperience && (
                <div className="VenuePage__Calendar-Wrapper">
                  <DropdownGroup
                    Analytics={Analytics}
                    isLargePartyConfigured={!!largePartyMessage}
                    isMobile={isMobile}
                    maxPartySize={maxQuantity}
                    minPartySize={minQuantity}
                    onPartySizeChange={$rootScope.searchProps?.onPartySizeChange}
                    onPartySizeClick={closeCalendar}
                    onTimeChange={onTimeChange}
                    onTimeClick={closeCalendar}
                    selectedDateFormatted={selectedDateFormatted}
                    selectedQuantity={selectedQuantity}
                    selectedTime={selectedTime}
                    calendarOpen={calendarOpen}
                    toggleCalendar={toggleCalendar}
                    dateLabel={dateLabel || ''}
                    venue={venue}
                  />
                  {calendarOpen && (
                    <div className="VenuePage__Calendar-Container">
                      <ResyCalendar
                        Analytics={Analytics}
                        $routeParams={$routeParams}
                        className="ResyCalendar__Dropdown"
                        clickableElementIdsToIgnore={[
                          'DropdownGroup__selector--date--selection',
                          'VenuePage__calendar__quick-picker__ellipsis',
                        ]}
                        numberOfMonths={1}
                        focusOnClose="#DropdownGroup__selector--date"
                        getAriaLabel={venueInventoryUtils.getAriaLabel}
                        calendarMap={inventoryByDay}
                        calendarCache={venueInventoryCache}
                        closeCalendar={toggleCalendar}
                        currentMonth={month}
                        onClick={handleDateSelect}
                        selectedDate={$routeParams.date}
                        venueCity={venue.location.city}
                      />
                      <div className="VenuePage__Calendar-Overlay" />
                    </div>
                  )}
                </div>
              )}

              {canRenderBookingExperience && renderQuickCalendar()}

              {renderGdaBanner()}

              {renderUSOpenBanner()}

              {canRenderBookingExperience
                && renderTodayEvents(todayEvents, inventoryByDay?.[$routeParams.date]?.reservation === STATE_AVAILABLE)}

              {canRenderBookingExperience && renderInventory(inventoryByDay)}
            </div>

            {renderGdaExclusive()}

            {partnershipBranding && (
              <PartnershipBranding {...partnershipBranding} image={partnershipBranding.logo} />
            )}

            {canRenderBookingExperience
              && renderTodayEvents(todayEvents, !(inventoryByDay?.[$routeParams.date]?.reservation === STATE_AVAILABLE))}

            <hr />

            {isResyCreditBannerEnabled && venue.isResyCreditEligible && <ResyCreditBanner useTempCopy={isResyCreditTempCopyEnabled} />}

            {needToKnow?.body
              && (
                <div className="VenuePage__need-to-know">

                  <TranslationProvider translationKey="venue_need_to_know_header">
                    <h2 className="VenuePage__content-title" data-test-id={`${testId}-need-to-know__title`}>
                      Need to Know
                    </h2>
                  </TranslationProvider>

                  <div className="VenuePage__context-text" data-test-id={`${testId}-need-to-know__body`}>
                    <ClampLines
                      text={needToKnow.body}
                      id="need-to-know"
                      moreText={getTranslation({
                        translationKey: 'venue_description_read_more',
                        fallback: 'Read more',
                      })}
                      lessText={getTranslation({
                        translationKey: 'venue_description_read_less',
                        fallback: 'Read less',
                      })}
                      lines={6}
                      buttons
                      ellipsis="..."
                    />
                  </div>
                </div>
              )}

            {aboutVenue?.body
              && (
                <div className="VenuePage__about">
                  <TranslationProvider translationKey="venue_about_header" translationValues={{ venueName: venue.name }}>
                    <h2 className="VenuePage__content-title" data-test-id={`${testId}-about-venue__title`}>
                      About
                      {' '}
                      {venue.name}
                    </h2>
                  </TranslationProvider>

                  <div className="VenuePage__context-text" data-test-id={`${testId}-about-venue__body`}>
                    <ClampLines
                      text={aboutVenue.body}
                      id="about-venue"
                      moreText={getTranslation({
                        translationKey: 'venue_description_read_more',
                        fallback: 'Read more',
                      })}
                      lessText={getTranslation({
                        translationKey: 'venue_description_read_less',
                        fallback: 'Read less',
                      })}
                      lines={6}
                      buttons
                      ellipsis="..."
                    />
                  </div>
                </div>
              )}
            {/* Adding some custom logic for US Open: https://resy.atlassian.net/browse/CON-13134 */}
            {!isUSOpenVenue && !isNomaVenue && (
              <UpcomingEvents
                appContext="consumer"
                isMobile={isMobile}
                upcomingEvents={futureEvents}
                venue={{
                  ...venue,
                }}
              />
            )}
          </div>

          <VenuePageSidebar
            affiliatedRestaurants={affiliatedRestaurants}
            ImageServiceConfig={ImageServiceConfig}
            isMobile={isMobile}
            venue={venue}
          />
        </div>

        {/* full-bleed below the grid */}
        {renderBlogContent()}
      </div>

      <resy-download>
        <Download $translate={$translate} />
      </resy-download>
    </>
  );
};

const venueContentShape = PropTypes.shape({
  attribution: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  body: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
});

const venuePagePropTypes = {
  $rootScope: PropTypes.shape({
    $broadcast: PropTypes.func,
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      xl: PropTypes.bool,
    }).isRequired,
    searchProps: PropTypes.shape({
      onPartySizeChange: PropTypes.func.isRequired,
      searchFields: PropTypes.shape({
        datepicker: PropTypes.shape({
          config: PropTypes.shape({
            label: PropTypes.string,
          }),
          model: momentPropTypes.momentObj,
        }),
      }),
    }),
    venueProps: PropTypes.shape({
      calendar: PropTypes.shape({
        scheduled: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    }),
  }).isRequired,
  $routeParams: PropTypes.shape({
    date: PropTypes.string,
    location: PropTypes.string,
    seats: PropTypes.string,
    venueSlug: PropTypes.string,
    shopsmall: PropTypes.string,
  }).isRequired,
  aboutVenue: venueContentShape,
  activeNotifications: PropTypes.shape({
    [PropTypes.number]: PropTypes.shape({
      start: PropTypes.string,
      end: PropTypes.string,
    }),
  }),
  affiliatedRestaurants: PropTypes.arrayOf(VenueShape),
  Analytics: PropTypes.shape({
    event: PropTypes.func.isRequired,
    setVenueName: PropTypes.func,
    setVenueInventory: PropTypes.func,
    setVenueId: PropTypes.func,
  }).isRequired,
  $translate: PropTypes.shape({
    proposedLanguage: PropTypes.func.isRequired,
    use: PropTypes.func.isRequired,
  }).isRequired,
  blogContent: PropTypes.arrayOf(BlogContentShape),
  clearTimeFilter: PropTypes.func.isRequired,
  containerQuery: containerQueryProps,
  filterQuery: PropTypes.shape({
    day: PropTypes.string,
    party_size: PropTypes.number,
    time_filter: PropTypes.string,
  }).isRequired,
  ImageServiceConfig: PropTypes.shape({
    baseRequestUrl: PropTypes.string,
  }).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isCenturionEligible: PropTypes.bool.isRequired,
  isPlatinumEligible: PropTypes.bool.isRequired,
  isFavorite: PropTypes.bool,
  isMobile: PropTypes.bool,
  isVenueClosed: PropTypes.bool.isRequired,
  largePartyMessage: PropTypes.string,
  loadingReservations: PropTypes.bool,
  maxQuantity: PropTypes.number,
  minQuantity: PropTypes.number,
  multiStepListModalName: PropTypes.string,
  multiStepListModalSlug: PropTypes.string,
  needToKnow: venueContentShape,
  nextAvailableDate: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
  nextAvailableDateFormatted: PropTypes.string,
  notifyData: PropTypes.shape({
    shouldShowRecommendations: PropTypes.bool,
    shouldShowTableConfigIdNotFound: PropTypes.bool,
    shouldShowTimeslotNotFound: PropTypes.bool,
    date: PropTypes.oneOfType([PropTypes.oneOf([null]), momentPropTypes.momentObj]),
    time: PropTypes.oneOfType([PropTypes.oneOf([null]), momentPropTypes.momentObj]),
  }).isRequired,
  onTimeChange: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  partnershipBranding: PropTypes.shape({
    alt: PropTypes.string,
    logo: PropTypes.string,
    name: PropTypes.string,
  }),
  platinumNight: PropTypes.shape({}),
  priceRange: PropTypes.string,
  recommendedVenues: PropTypes.arrayOf(PropTypes.shape({})),
  reservations: ReservationShape,
  searchSessionId: PropTypes.string,
  selectedDate: PropTypes.string.isRequired,
  selectedDateFormatted: PropTypes.string.isRequired,
  selectedQuantity: PropTypes.number,
  selectResy: PropTypes.func,
  selectedTime: PropTypes.string,
  setSelectedCoreISODate: PropTypes.func.isRequired,
  showAuthModal: PropTypes.func.isRequired,
  upcomingEvents: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    end_time: PropTypes.string,
    general_sale_date: PropTypes.string,
    image_preview: PropTypes.string,
    is_global_dining_access: PropTypes.bool,
    name: PropTypes.string,
    time: PropTypes.string,
    url_slug: PropTypes.string,
  })),
  userIsGda: PropTypes.bool,
  userIsPlatinumNight: PropTypes.bool,
  venue: VenueShape.isRequired,
  venueInventory: PropTypes.shape({
    scheduled: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  venueInventoryCache: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      scheduled: PropTypes.arrayOf(PropTypes.shape({
        date: PropTypes.string,
        inventory: PropTypes.arrayOf(PropTypes.shape({
          event: PropTypes.oneOf([STATE_AVAILABLE, NOT_AVAILABLE]),
          reservation: PropTypes.oneOf([STATE_AVAILABLE, NOT_AVAILABLE]),
          'walk-in': PropTypes.oneOf([STATE_AVAILABLE, NOT_AVAILABLE]),
        })),
      })),
      last_calendar_day: PropTypes.string,
    }),
  }),
  whyWeLikeIt: venueContentShape,
  setReservation: PropTypes.func.isRequired,
  setMultiStepModalVenueContext: PropTypes.func.isRequired,
  setMultiStepModalVenueId: PropTypes.func.isRequired,
  setMultiStepModalMode: PropTypes.func.isRequired,
  setMultiStepModalOpenState: PropTypes.func.isRequired,
};
VenuePage.propTypes = venuePagePropTypes;

VenuePage.defaultProps = {
  aboutVenue: null,
  activeNotifications: {},
  affiliatedRestaurants: [],
  blogContent: [],
  containerQuery: {},
  isFavorite: false,
  isMobile: false,
  largePartyMessage: '',
  loadingReservations: false,
  maxQuantity: 25,
  minQuantity: undefined,
  multiStepListModalName: undefined,
  multiStepListModalSlug: undefined,
  needToKnow: null,
  nextAvailableDate: null,
  nextAvailableDateFormatted: null,
  partnershipBranding: null,
  platinumNight: null,
  priceRange: '$',
  recommendedVenues: [],
  reservations: [],
  searchSessionId: '',
  selectResy: () => { },
  selectedQuantity: 2,
  selectedTime: '',
  upcomingEvents: [],
  userIsGda: false,
  userIsPlatinumNight: false,
  venueInventory: {},
  venueInventoryCache: {},
  whyWeLikeIt: null,
};

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: selectIsAuthenticated(state),
  isCenturionEligible: selectIsCenturionEligible(state),
  isPlatinumEligible: selectIsPlatinumEligible(state),
  isFavorite: !!(state.favoriteVenues.venuesByUser[ownProps.venue.id]),
  searchSessionId: state?.venueSearch?.metadata?.searchSessionId,
});

const mapDispatchToProps = {
  setSelectedCoreISODate,
  setReservation,
  setMultiStepModalVenueContext,
  setMultiStepModalVenueId,
  setMultiStepModalMode,
  setMultiStepModalOpenState,
};

export { getUSOpenEligibilityByExclusiveId, venuePagePropTypes, VenuePage as ComponentUnderTest };
export default connect(mapStateToProps, mapDispatchToProps)(VenuePage);
